"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _HeaderCell = _interopRequireDefault(require("./HeaderCell"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * A Simple Table component renders a basic, responsive table.
 */
const SimpleTable = _ref => {
  let {
    tableCaption,
    children
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "table-responsive"
  }, /*#__PURE__*/_react.default.createElement("table", {
    className: "mm-table"
  }, /*#__PURE__*/_react.default.createElement("caption", null, tableCaption), children));
};
SimpleTable.propTypes = {
  /**
   * The contents and structure of the Table.
   */
  children: _propTypes.default.node.isRequired,
  /**
   * A caption describes the purpose and content of this instance of Simple Table.
   */
  tableCaption: _propTypes.default.string.isRequired
};
SimpleTable.defaultProps = {
  tableCaption: 'Data Table'
};
SimpleTable.HeaderCell = _HeaderCell.default;
var _default = exports.default = SimpleTable;